/* import axios from 'axios' */
import { authAxios } from './../../../../bibliotecas/seguranca/authAxios'
import { errorHandler } from './../../../erro/errorHandler'

export default {
  obterTodos () {
    let promisse = authAxios().get(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios`)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  obterPorId (id) {
    let promisse = authAxios().get(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${id}`)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  obterPorIdComPerfisAcesso (usuarioId) {
    let promisse = authAxios().get(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioId}/perfisacesso`)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  inserirUsuario (usuario) {
    let promisse = authAxios().post(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios`, usuario)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  atualizarUsuario (usuario) {
    let promisse = authAxios().put(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios`, usuario)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  associarPerfilAcesso (usuarioPerfilAcesso) {
    let promisse = authAxios().post(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioPerfilAcesso.usuarioId}/perfilacesso`, usuarioPerfilAcesso)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  associarPerfisAcesso (usuarioPerfisAcesso) {
    let promisse = authAxios().post(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioPerfisAcesso.usuarioId}/perfisacesso`, usuarioPerfisAcesso)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  desassociarPerfilAcesso (usuarioPerfilAcesso) {
    let promisse = authAxios().patch(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioPerfilAcesso.usuarioId}/perfilacesso`, usuarioPerfilAcesso)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  desassociarPerfisAcesso (usuarioPerfisAcesso) {
    let promisse = authAxios().patch(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioPerfisAcesso.usuarioId}/perfisacesso`, usuarioPerfisAcesso)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  associarCredores (usuarioCredores) {
    let promisse = authAxios().post(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioCredores.usuarioId}/credores`, usuarioCredores)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  desassociarCredor (usuarioCredor) {
    let promisse = authAxios().patch(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioCredor.usuarioId}/credor`, usuarioCredor)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  desassociarCredores (usuarioCredores) {
    let promisse = authAxios().patch(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioCredores.usuarioId}/credores`, usuarioCredores)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  ativarDesativarUsuario (usuarioId) {
    let promisse = authAxios().patch(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioId}/ativardesativar`)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  resetarSenhaUsuario (usuarioId) {
    let promisse = authAxios().patch(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioId}/resetarsenha`)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  trocarSenhaUsuario (usuarioId, trocaSenha) {
    let promisse = authAxios().patch(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioId}/trocarsenha`, trocaSenha)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  },

  salvarFuncionario (usuarioFuncionario) {
    let promisse = authAxios().post(`${process.env.ROOT_URL}${process.env.ROOT_API}/admin/controleacesso/usuarios/${usuarioFuncionario.usuarioId}/funcionario`, usuarioFuncionario)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modulos/admin/controleacesso/usuarios/UsuariosServicos.js